export * from './clone.pipe';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/clone/index.ts